
import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import VendorService from "../../services/VendorServices";
import MasterLocationService from "../../services/MasterLocationService";
import Breadcrumb from "../../components/Breadcrumb";
import StorageService from "../../services/StorageService";
import VendorCategoryService from "../../services/VendorCategoryService";
import MessageDialog from "../../components/MessageDialog";


export default function AddVendor() {
  // const [companyName, setCompanyName] = useState("Default Company");
  const [loading, setLoading] = useState(false);
  const [locationLoaded, setLocationLoaded] = useState(false);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("success");
  const currentYear = new Date().getFullYear();
  const [editItem, setEditItem] = useState(null);
  const [vendorId, setVendorId] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();
  // const messageTimer = useRef(null);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [vendorCategory, setVendorCategory] = useState([]);
  // const messageBoxRef = useRef(null);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    // reValidateMode: "onChange",
  });

  const country = watch("countryId");
  const state = watch("state");

  const showMessage = (text, type = "success") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  // useEffect(() => {
  //   if (message && messageBoxRef.current) {
  //     const yOffset = -120; //adjust this value if needed
  //     const y =
  //       messageBoxRef.current.getBoundingClientRect().top +
  //       window.pageYOffset +
  //       yOffset;

  //     window.scrollTo({
  //       top: y,
  //       behavior: "smooth",
  //     });
  //   }
  // }, [message]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const data = await MasterLocationService.getAllCountries();
        setCountries(data || []);
      } catch (err) {
        console.error("Error fetching countries:", err);
        setCountries([]);
      }
    };
    fetchCountries();
  }, []);

  useEffect(() => {
    if (country) {
      const fetchStates = async () => {
        try {
          const data = await MasterLocationService.getStatesByCountry(country);
          setStates(data || []);
          if (!editMode) {
            setValue("state", "");
            setCities([]);
            setValue("city", "");
          }
        } catch (err) {
          console.error("Error fetching states:", err);
          setStates([]);
          setCities([]);
          setValue("state", "");
          setValue("city", "");
        }
      };
      fetchStates();
    } else {
      setStates([]);
      setCities([]);
      setValue("state", "");
      setValue("city", "");
    }
  }, [country, setValue, editMode]);

  useEffect(() => {
    if (state) {
      const fetchCities = async () => {
        try {
          const data = await MasterLocationService.getCitiesByState(state);
          setCities(data || []);
          if (!editMode) setValue("city", "");
        } catch (err) {
          console.error("Error fetching cities:", err);
          setCities([]);
          if (!editMode) setValue("city", "");
        }
      };
      fetchCities();
    } else {
      setCities([]);
      if (!editMode) setValue("city", "");
    }
  }, [state, setValue, editMode]);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const res = await VendorCategoryService.getActive();
        const categories = res?.data || res || [];
        setVendorCategory(categories);
        console.log("Vendor categories loaded:", categories?.length ?? 0);
      } catch (err) {
        console.error("Error loading vendor categories:", err);
        setVendorCategory([]);
      }
    };

    loadCategories();
  }, []);

  useEffect(() => {
    const loadVendor = async () => {
      if (!id) return;



      setEditMode(true);


      try {
        setEditLoading(true);
        const res = await VendorService.getById(id);
        const vendor = res.data;
        // const vendor = res.data?.[0];
        setEditItem(vendor);

        const countryList = await MasterLocationService.getAllCountries();
        setCountries(countryList || []);
        if (vendor.countryId !== undefined && vendor.countryId !== null) {
          setValue("countryId", String(vendor.countryId));
        }

        const stateList = await MasterLocationService.getStatesByCountry(
          vendor.countryId || ""
        );
        setStates(stateList || []);

        let selectedStateId = null;
        if (vendor.state) {
          const foundState = (stateList || []).find(
            (s) =>
              String(s.stateName).trim().toLowerCase() ===
              String(vendor.state).trim().toLowerCase()
          );
          if (foundState) {
            selectedStateId = foundState.id;
            setValue("state", String(foundState.id));
          }
        }

        const cityStateId = selectedStateId || vendor.stateId || "";
        const cityList = cityStateId
          ? await MasterLocationService.getCitiesByState(cityStateId)
          : [];
        setCities(cityList || []);

        if (vendor.city && cityList && cityList.length) {
          const foundCity = cityList.find(
            (c) =>
              String(c.cityName).trim().toLowerCase() ===
              String(vendor.city).trim().toLowerCase()
          );
          if (foundCity) {
            setValue("city", String(foundCity.id));
          }
        }
        const catRes = await VendorCategoryService.getActive();
        const categories = catRes?.data || [];
        setVendorCategory(categories);

        const vendorCatName =
          vendor.vendorCategoryName ||
          vendor.vendorcategoryname ||
          vendor.categoryName ||
          vendor.category ||
          "";

        if (vendor.vendorCategoryId) {
          setValue("vendorCategoryId", String(vendor.vendorCategoryId));
        } else {
          const foundCat = categories.find((c) =>
            c.vendorCategoryName
              .trim()
              .toLowerCase()
              .includes(String(vendorCatName).trim().toLowerCase())
          );

          if (foundCat) {
            setValue("vendorCategoryId", String(foundCat.id));
          } else {
            console.log(
              "Vendor Category Mismatch → Backend sent:",
              vendorCatName,
              " | Dropdown has:",
              categories
            );
          }
        }

        Object.keys(vendor).forEach((key) => {
          if (
            ![
              "countryId",
              "state",
              "stateId",
              "city",
              "cityId",
              "vendorCategoryId",
              "vendorCategoryName",
            ].includes(key)
          ) {
            const val = vendor[key];
            if (val !== undefined && val !== null) {
              if (
                !["countryId", "state", "city", "vendorCategoryId"].includes(
                  key
                )
              ) {
                setValue(key, val);
              }
            }
          }
        });
      } catch (error) {
        console.error("Modify Load Error:", error);
      }
      setEditLoading(false);

    };

    loadVendor();
  }, [id, setValue, reset]);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      let res;

      if (editMode && editItem?.id) {
        data.updatedBy = StorageService.loginData().employeeId;
        res = await VendorService.update(editItem.id, data);
      } else {
        data.companyId = StorageService.activeCompany().companyId;
        data.createdBy = StorageService.loginData().employeeId;
        res = await VendorService.create({ ...data, status: "Active" });
      }

      console.log("Save Response:", res);

      if (res?.status) {
        showMessage(
          editMode
            ? "Vendor updated successfully."
            : "Vendor added successfully.",
          "success"
        );
        setTimeout(() => {
          localStorage.removeItem("editItem");
          navigate("/cpnl/vendors/view");
        }, 1000);
      } else {
        showMessage(res?.message || "Failed to save Vendor.", "error");
      }
    } catch (error) {
      console.error("Error saving vendor:", error);
      const msg =
  error.response?.data?.error ||   // ✅ use actual error first
  error.response?.data?.message ||
  error.message ||
  "Error saving vendor";
      showMessage(msg, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    localStorage.removeItem("editItem");
    reset();
    navigate("/cpnl/vendors/view");
  };

  return (
    <>
      <Breadcrumb
        pageTitle={editMode ? "Modify Vendor" : "Add Vendor"}
        secondTitle="Masters"
      ></Breadcrumb>
      <div className="row">
        <div className="card py-2 bg-white shadow-sm">
          {/* {message && (
            <div
              ref={messageBoxRef}
              className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
                }`}
            >
              {message}
            </div>
          )} */}

          
            <MessageDialog
              message={message}
              type={msgType}
              setMessage={setMessage}
              setMsgType={setMsgType}
            />
          

          {editLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary"></div>
              <div className="mt-2 text-muted">Loading vendor data...</div>
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)} noValidate>
              {/* Row 1 */}
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">
                    Vendor Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Vendor Name"
                    {...register("vendorName", {
                      required: "Vendor Name is required",
                      minLength: { value: 3, message: "At least 3 characters" },
                    })}
                  />
                  {errors.vendorName && (
                    <small className="text-danger">
                      {errors.vendorName.message}
                    </small>
                  )}
                </div>

                <div className="mb-3 col-md-6">
                  <label className="form-label">
                    Vendor Code <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Vendor Code"
                    {...register("vendorCode", {
                      required: "Vendor Code is required",
                    })}
                    onInput={(e) => {
                      e.target.value = e.target.value.toUpperCase();
                    }}
                  />
                  {errors.vendorCode && (
                    <small className="text-danger">
                      {errors.vendorCode.message}
                    </small>
                  )}
                </div>
              </div>

              {/* Row 2 */}
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">
                    Contact First Name
                  </label>
                  <input
                    type="text"
                    placeholder="First Name"
                    className="form-control"
                    {...register("firstName")}
                  />
                  {errors.firstName && (
                    <small className="text-danger">
                      {errors.firstName.message}
                    </small>
                  )}
                </div>

                <div className="mb-3 col-md-6">
                  <label className="form-label">
                    Contact Last Name  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Last Name"
                    {...register("lastName")}
                  />
                  {errors.lastName && (
                    <small className="text-danger">
                      {errors.lastName.message}
                    </small>
                  )}
                </div>
              </div>

              {/* Row 3 */}
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">
                    Email ID
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email ID"
                    {...register("emailId", {
                      pattern: {
                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                        message: "Enter a valid email address",
                      },
                    })}
                  />
                  {errors.emailId && (
                    <small className="text-danger">
                      {errors.emailId.message}
                    </small>
                  )}
                </div>

                <div className="mb-3 col-md-6">
                  <label className="form-label">
                    Mobile No
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="10-digit Mobile No"
                    {...register("mobileNo", {
                      pattern: {
                        value: /^[0-9]{10}$/,
                        message: "Enter a valid 10-digit mobile number",
                      },
                    })}
                  />
                  {errors.mobileNo && (
                    <small className="text-danger">
                      {errors.mobileNo.message}
                    </small>
                  )}
                </div>
              </div>

              {/* Row 4 */}
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">Phone</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Phone"
                    {...register("phone")}
                  // { required: "Phone is required" })}
                  />
                  {/* {errors.phone && (
                  <small className="text-danger">{errors.phone.message}</small>
                )} */}
                </div>

                <div className="mb-3 col-md-6">
                  <label className="form-label">Fax</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Fax"
                    {...register("fax")}
                  />
                </div>
              </div>

              {/* Row 5 */}
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">
                    Address
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Address"
                    {...register("address")}
                  />
                  {errors.address && (
                    <small className="text-danger">
                      {errors.address.message}
                    </small>
                  )}
                </div>

                {/* <div className="mb-3 col-md-6">
                <label className="form-label">Address 2</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Address 2"
                  {...register("address2")}
                />
              </div> */}
                {/* </div> */}

                {/* Row 6 */}
                {/* <div className="row">
              <div className="mb-3 col-md-6">
                <label className="form-label">Address 3</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Address 3"
                  {...register("address3")}
                />
              </div> */}

                <div className="mb-3 col-md-6">
                  <label className="form-label">Landmark</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Landmark"
                    {...register("landMark")}
                  />
                </div>
              </div>

              {/* Row 7 */}
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">Website</label>
                  <input
                    type="url"
                    className="form-control"
                    placeholder="Website"
                    {...register("website")}
                  />
                </div>

                <div className="mb-3 col-md-6">
                  <label className="form-label">Logo Small URL</label>
                  <input
                    type="url"
                    className="form-control"
                    placeholder="Logo Small URL"
                    {...register("logoSmallURL")}
                  />
                </div>
              </div>

              {/* Row 8 */}
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">Logo Big URL</label>
                  <input
                    type="url"
                    className="form-control"
                    placeholder="Logo Big URL"
                    {...register("logoBigURL")}
                  />
                </div>

                <div className="mb-3 col-md-6">
                  <label className="form-label">
                    Country <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    {...register("countryId", {
                      required: "Country is required",
                    })}
                  >
                    <option value="">Select Country</option>
                    {countries.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.countryName}
                      </option>
                    ))}
                  </select>
                  {errors.country && (
                    <small className="text-danger">
                      {errors.country.message}
                    </small>
                  )}
                </div>
              </div>

              {/* Row 9 */}
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">
                    State <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    {...register("state", { required: "State is required" })}
                  >
                    <option value="">Select State</option>
                    {states.map((s) => (
                      <option key={s.id} value={s.id}>
                        {s.stateName}
                      </option>
                    ))}
                  </select>
                  {errors.state && (
                    <small className="text-danger">{errors.state.message}</small>
                  )}
                </div>

                <div className="mb-3 col-md-6">
                  <label className="form-label">
                    District <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    {...register("city", { required: "District is required" })}
                  >
                    <option value="">Select District</option>
                    {cities.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.cityName}
                      </option>
                    ))}
                  </select>
                  {errors.city && (
                    <small className="text-danger">{errors.city.message}</small>
                  )}
                </div>
              </div>

              {/* Row 10 */}
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">Zip</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Zip"
                    {...register("zip")}
                  />
                </div>

                <div className="mb-3 col-md-6">
                  <label className="form-label">
                    Establishment Year
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="YYYY"
                    {...register("estableshmentYear", {
                      valueAsNumber: true,
                      validate: (v) => {
                        // if (!v) return "Year required";
                        if (v < 1900 || v > currentYear)
                          return `Enter year between 1900 and ${currentYear}`;
                        return true;
                      },
                    })}
                  />
                  {errors.estableshmentYear && (
                    <small className="text-danger">
                      {errors.estableshmentYear.message}
                    </small>
                  )}
                </div>
              </div>

              {/* Row 11 */}
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">
                    PAN
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="PAN"
                    {...register("PAN", {
                      pattern: {
                        value: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
                        message: "PAN must be 10 characters (e.g. AAAAA9999A)",
                      },
                    })}
                    onInput={(e) => {
                      e.target.value = e.target.value.toUpperCase();
                    }}
                  />
                  {errors.PAN && (
                    <small className="text-danger">{errors.PAN.message}</small>
                  )}
                </div>

                <div className="mb-3 col-md-6">
                  <label className="form-label">TAN</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="TAN"
                    {...register("TAN", {
                      pattern: {
                        value: /^[A-Z]{4}[0-9]{5}[A-Z]$/,
                        message: "TAN must be 10 characters (e.g. AAAA99999A)",
                      },
                    })}
                    onInput={(e) => {
                      e.target.value = e.target.value.toUpperCase();
                    }}
                  />
                  {errors.TAN && (
                    <small className="text-danger">{errors.TAN.message}</small>
                  )}
                </div>
              </div>

              {/* Row 12 */}
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">
                    GSTN
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="GSTN"
                    {...register("GSTN", {
                      pattern: {
                        value: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/,
                        message: "GSTN must be 15 characters",
                      },
                    })}
                    onInput={(e) => {
                      e.target.value = e.target.value.toUpperCase();
                    }}
                  />
                  {errors.GSTN && (
                    <small className="text-danger">{errors.GSTN.message}</small>
                  )}
                </div>

                <div className="mb-3 col-md-6">
                  <label className="form-label">CIN</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="CIN"
                    {...register("CIN", {
                      minLength: {
                        value: 21,
                        message: "CIN must be 21 characters",
                      },
                      maxLength: {
                        value: 21,
                        message: "CIN must be 21 characters",
                      },
                    })}
                  />
                  {errors.CIN && (
                    <small className="text-danger">{errors.CIN.message}</small>
                  )}
                </div>
              </div>

              {/* Row 13 */}
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">Trademark No</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Trademark No"
                    {...register("trademarkNo")}
                  />
                </div>
                {
                  <div className="mb-3 col-md-6">
                    <label className="form-label">
                      Vendor Category <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select"
                      {...register("vendorCategoryId", {
                        required: "Vendor Category is required",
                      })}
                    >
                      <option value="">Select Category</option>
                      {vendorCategory.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.vendorCategoryName}
                        </option>
                      ))}
                    </select>
                    {errors.vendorCategoryId && (
                      <small className="text-danger">
                        {errors.vendorCategoryId.message}
                      </small>
                    )}
                  </div>
                }
              </div>

              {/* Row 14 */}
              <div className="row">
                <div className="mb-3 col-md-12">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="isTransporter"
                      {...register("isTransporter")}
                    />
                    <label className="form-check-label ms-2" htmlFor="isTransporter">
                      Also register as Transporter
                    </label>
                  </div>
                </div>
              </div>

              <div className="mt-3">
                <button
                  type="submit"
                  className="btn btn-primary me-2"
                  disabled={loading}
                >
                  <i class="ti ti-circle-check me-1"></i>
                  {loading
                    ? editItem
                      ? "Updating..."
                      : "Saving..."
                    : editItem
                      ? "Update"
                      : "Save"}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCancel}
                >
                  <i class="ti ti-cancel me-1"></i>
                  Cancel
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
}

